export const getFlexibilityIsEditable = (obj: {
  flexibilityConstraints: { allowedToModify: boolean | null } | null;
}) => !!obj.flexibilityConstraints?.allowedToModify;

export default getFlexibilityIsEditable;
